import { apiClient } from "./api";

const ROOT = "/device-ota/admin";

export const deviceOtaApi = {
  overview: () => apiClient.get(`${ROOT}/overview`),
  devices: () => apiClient.get(`${ROOT}/devices`),
  device: (deviceId) => apiClient.get(`${ROOT}/devices/${encodeURIComponent(deviceId)}`),
  reboot: (deviceId) => apiClient.post(`${ROOT}/devices/${encodeURIComponent(deviceId)}/reboot`, {}),
  releases: () => apiClient.get(`${ROOT}/releases`),
  assign: (deviceId, releaseId) => apiClient.post(`${ROOT}/assignments`, { deviceId, releaseId }),
  unassign: (deviceId) => apiClient.delete(`${ROOT}/assignments/${encodeURIComponent(deviceId)}`),
  promote: (releaseId) => apiClient.post(`${ROOT}/releases/${encodeURIComponent(releaseId)}/promote`, {}),
  revoke: (releaseId) => apiClient.post(`${ROOT}/releases/${encodeURIComponent(releaseId)}/revoke`, {}),
  events: (filters = {}) => {
    const query = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
      if (value) query.set(key, value);
    });
    const suffix = query.toString();
    return apiClient.get(`${ROOT}/events${suffix ? `?${suffix}` : ""}`);
  },
};